<script setup>
import { onMounted, reactive,ref} from 'vue'
import ManGroup from '../ManGroup.vue'
import { useMetaStore } from '@/stores'
import { get, post, qsel, serverDt, uuid, validators, ymd } from '@/common/util'
import ConfirmCard from '@/components/ConfirmCard.vue'
import _ from 'lodash-es'
import { useRouter } from 'vue-router'
import 'vue3-tree-vue/dist/style.css'
import Vue3TreeVue from 'vue3-tree-vue'
const metaStore=useMetaStore(),router=useRouter(),meta=reactive({search:{page:1,size:20,sortcol:'mdt',isasc:false,where:{nm:'',groupid_eq_:null}},tartbl:'Streetview',tblheight:400,data:{rows:[]}
  ,heads:[{tk:'uniquenumber',col:'id'},{tk:'streetview_name',col:'nm'},{tk:'count',col:'ttlcnt'},{tk:'type',col:'layertype'},{tk:'coordinatesystem',col:'epsg'},{tk:'dateofmod',col:'mdt'},{tk:'status',col:'processstatus'}]
  ,initsv:{nm:'',inputtype:'directinput',epsg:4326,groupid:'defaultgroups',layertype:'NodeLink',etc:null},upfiletype:'dir',upfiles:[],detectptdist:12,linkdist:3,upfiledt:new Date(),layertypes:['Point','LineString','NodeLink']
  ,upfilepostype:'nmea',upfilenmeaext:'txt',upproctype:'standalone',upfilesection:'local',serverfiles:[]})
  ,mangroup=ref(null)
,toEdit=(id)=>{
  metaStore.searchParams.streetview={...meta.search}
  router.push({path: '/admin/editsv/' + id})
},delSv=async (id)=>{
  metaStore.blockLoading()
  const res=await post('rest/authed/admin/data/delsv',{id:id})
  metaStore.blockLoading(false)
  metaStore.toastRslt(res,false)
  search()
},uploadSv=async()=>{
  if(!meta.selid)return metaStore.toast('선택된 거리뷰가 없습니다.',false)
  if(!_.isNumber(meta.detectptdist))return metaStore.toast('기존 점 거리가 유효하지 않습니다.',false)
  if(!_.isNumber(meta.linkdist))return metaStore.toast('연결거리가 유효하지 않습니다.',false)
  if(meta.upfilesection=='local'&&meta.upfiles.length==0)return metaStore.toast('업로드된 파일이 없습니다.',false)
  if(meta.upfilesection=='server'){
    if(!meta.seldir)return metaStore.toast('서버 파일/폴더가 선택되지 않았습니다.',false)
    if(meta.serverfiles.filter(sf=>sf.meta.isroot).findIndex(r=>r.id==meta.seldir?.id)>-1)return metaStore.toast('루트 디렉토리는 선택할 수 없습니다.',false)
    if(meta.upfiletype=='zip'&&!meta.seldir?.name.toLowerCase().endsWith('.zip'))return metaStore.toast('ZIP파일 업로드 시 ZIP파일을 선택해야 합니다.',false)
  }
  meta.data.rows.find(r => r.id == meta.selid).processstatus='sendfiletoserver'
  metaStore.blockLoading()
  setTimeout(()=>{
    if(meta.upfilesection=='local'){
      const svnm=meta.data.rows.find(sv=>sv.id==meta.selid).nm
      metaStore.blockLoading(false)
      metaStore.toastAndUploadSv({svid:meta.selid,files:meta.upfiles,detectptdist:meta.detectptdist,linkdist:meta.linkdist,upfiledt:meta.upfiledt
        ,upfilenmeaext:meta.upfilenmeaext,upfilepostype:meta.upfilepostype,upproctype:meta.upproctype
        ,upfilesection:meta.upfilesection,serverpath:meta.seldir?.meta?.path,svnm,callback:finUpload})
    }else if(meta.upfilesection=='server'){
      post('rest/authed/admin/data/procsvserverfiles',{
        svid:meta.selid,
        detectptdist:meta.detectptdist,
        linkdist:meta.linkdist,
        upfiledt:serverDt(meta.upfiledt),
        upfilenmeaext:meta.upfilenmeaext,
        upfilepostype:meta.upfilepostype,
        upproctype:meta.upproctype,
        serverpath:meta.seldir?.meta?.path,
        upfilesection:meta.upfilesection
      },res=>{
        metaStore.blockLoading(false)
        const selsv=meta.data.rows.find(r => r.id == res.data.svid)
        if(!res.isSuccess){
          selsv.processstatus='complete'
          return metaStore.toastRslt(res,false);
        }
        const svnm=selsv.nm
        metaStore.toastAndChkUpSvProc(res.data.bpid,svnm,res.data.svid,finUpload)
      },err=>{
        metaStore.blockLoading(false)
        metaStore.toastRslt(err,false)
      })
    }
    pop()
  },300)
},finUpload=async(ids)=>{
  if(ids&&ids.svid){
    let svIdx = meta.data.rows.findIndex(r => r.id == ids.svid);
    if (svIdx>-1) {
      let res = await post('rest/authed/member/searchstreetviews', {page: 1,size: 1, where: { id_eq_: ids.svid }})
      if (res.isSuccess && res.data.rows && res.data.rows.length > 0) {
        meta.data.rows[svIdx] = res.data.rows[0]
        res=await get('rest/authed/admin/data/cntpanobysvids?svids='+ids.svid)
        if(res.isSuccess&&res.data)meta.data.rows[svIdx].ttlcnt=res.data[ids.svid]||0
      }
    }
  }
},addSv=async ()=>{
  meta.addoverlay='loading'
  metaStore.blockLoading()
  if(meta.selgroup&&!meta.selgroup.id)meta.newsv.groupid=meta.selgroup.id
  if(meta.newsv.groupid=='defaultgroups')meta.newsv.groupid=null
  const res=await post('rest/authed/admin/data/addsv',meta.newsv)
  metaStore.blockLoading(false)
  if(!res.isSuccess)pop('add')
  meta.addoverlay=null
  metaStore.toastRslt(res)
  if(res.isSuccess)search()
},pop=async (type,id)=>{
  meta.poptype=null
  meta.selid=id
  let persist=false
  if(type=='add'){
    meta.newsv={...meta.initsv}
    meta.newsv.groupid=meta.selgroup?meta.selgroup.id:'defaultgroups'
    meta.upfiles=[]
    persist=true
  }
  if(type=='upload'){
    const selrow=meta.data.rows.find(row=>row.id==id)
    if(selrow.bpid){
      if(metaStore.upproctoasts[selrow.bpid]==null)metaStore.toastAndChkUpSvProc(selrow.bpid,selrow.nm,selrow.id)
      return
    }
    meta.linkdist=null
    meta.detectptdist=null
    meta.upfilepostype='nmea'
    meta.upfiletype='zip'
    meta.upfilesection='local'
    meta.upfiles=[]
    meta.seldir=null
  }
  metaStore.pop({ison:type!=null,persist,callback:()=>meta.poptype=type})
},initGroups=async()=>{
  metaStore.blockLoading()
  const res=await get('rest/authed/member/groups/'+meta.tartbl)
  metaStore.blockLoading(false)
  meta.groups=res.data
  meta.groups.unshift({id:'defaultgroups',nm:metaStore.t('defaultgroups'),tartbl:meta.tartbl})
},groupSelected=group=>{
  meta.selgroup=group
  meta.search.where.groupid_eq_=group?group.id:null
  meta.search.page=1
  search()
},groupUpdated=async groups=>{
  await initGroups()
  await search()
},serverFiles=async(type)=>{
  const dirpath=meta.seldir?.meta?.path
  if(meta.seldir&&!meta.seldir.meta.isdir)return
  meta.uploadoverlay='loading'
  let res,toTreeItem=sf=>({name:sf.name,id:uuid(),meta:{isdir:sf.isdir,path:sf.path,childcnt:sf.childcnt},children:[]})
  if(!dirpath){
    res=await get('rest/authed/admin/rootdirs')
    meta.serverfiles=res.data.map(toTreeItem)
    meta.serverfiles.forEach(item=>item.meta.isroot=true)
    meta.seldir=null
  }else{
    res=await post(`rest/authed/admin/dirchildren`,{type,dirpath})
    if(meta.seldir&&res.data){
      meta.seldir.expanded=true
      meta.seldir.children=res.data.map(toTreeItem)
    }
  }
  setTimeout(() =>meta.uploadoverlay=null, 500);
},mountDisk=async()=>{
  meta.uploadoverlay='loading'
  const res=await get('rest/authed/admin/mountmedia')
  if(res.isSuccess){
    meta.seldir=null
    serverFiles()
  }else metaStore.toastRslt(res,false)
  setTimeout(() =>meta.uploadoverlay=null, 500);
},unmountDisk=async()=>{
  meta.uploadoverlay='loading'
  const res=await get('rest/authed/admin/unmountmedia')
  if(res.isSuccess){
    meta.seldir=null
    serverFiles()
  }else metaStore.toastRslt(res,false)
  setTimeout(() =>meta.uploadoverlay=null, 500);
},search=async()=>{
  metaStore.blockLoading()
  let res=await post('rest/authed/member/searchstreetviews',meta.search)
  metaStore.blockLoading(false)
  meta.data=res.data
  if(meta.data&&meta.data.rows&&meta.data.rows.length>0){
    res=await get('rest/authed/admin/data/cntpanobysvids?svids='+meta.data.rows.map(row=>row.id).toString())
    if(res.isSuccess&&res.data){
      const svids=[]
      _.entries(res.data).forEach(([svid,cnt])=>{
        const sv=meta.data.rows.find(r=>r.id==svid)
        if(sv)sv.ttlcnt=cnt
        else sv.ttlcnt=0
        svids.push(svid)
      })
      res=await get('rest/authed/admin/data/backprocinfosbysvids/'+svids.toString())
      if(res.data)res.data.forEach(binfo=>{
        const sv=meta.data.rows.find(r=>r.id==binfo.svid)
        if(sv)sv.bpid=binfo.id
      })
    }
  }
  meta.tblheight=window.innerHeight-380
}
if(metaStore.dispmode=='minimum'){
  meta.layertypes.splice(2,1)
  meta.initsv.layertype='Point'
}
if(metaStore.searchParams.streetview){
  meta.search={...metaStore.searchParams.streetview}
  metaStore.searchParams.streetview=null
}
search()
initGroups()
// onMounted(()=>{
//   router.replace('/admin/mandata/registermanageroadview/')
// })
</script>
<template>
  <v-row no-gutters w class="h-100 flex-nowrap">
    <v-col style="max-width: 485px;">
      <ManGroup ref="mangroup" :tartbl="meta.tartbl" :ispop="false" :usedefaultgroup="true" @on-sel="groupSelected" @on-update="groupUpdated"/>
    </v-col>
    <v-col class="mansvcol">
      <v-card flat :title="meta.selgroup?meta.selgroup.nm:$t('defaultgroups')">
        <v-row>
          <v-col cols="6"><v-text-field hide-details variant="outlined" density="compact" class="ms-3" :label="$t('streetview_name')" :placeholder="$t('enteranameforthesvupto50characters')" v-model="meta.search.where.nm"/></v-col>
          <v-col><v-btn prepend-icon="mdi-magnify" color="secondary" :text="$t('search')" @click="search"/></v-col>
          <v-col class="text-right pe-7">
            <v-btn color="primary" :text="$t('registersv')" @click="pop('add')"/>
            <v-btn class="ms-3" :text="$t('refresh')" @click="search"/>
          </v-col>
        </v-row>
        <v-card-text>
          <v-table class="mansvtbl" fixed-header :height="meta.tblheight">
            <thead>
              <tr>
                <th class="text-no-wrap" v-for="head in meta.heads">{{ $t(head.tk) }}</th>
                <th>{{ $t('viewdetails') }}</th>
                <th v-if="metaStore.dispmode!='minimum'">{{ $t('uploadingfiles') }}</th>
                <th>{{ $t('delete') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in meta.data.rows">
                <td v-for="head in meta.heads" class="text-no-wrap">
                  <div v-if="head.col=='mdt'">{{ ymd(row.mdt) }}</div>
                  <div v-else-if="head.col=='layertype'||head.col=='processstatus'">{{$t(row[head.col])}}</div>
                  <div v-else>{{ row[head.col] }}</div>
                </td>
                <td class="text-center"><v-btn :disabled="row.processstatus!='complete'" :text="$t('viewdetails')" @click="toEdit(row.id)"/></td>
                <td v-if="metaStore.dispmode!='minimum'" class="text-center"><v-btn v-if="row.layertype!='LineString'" :disabled="row.processstatus!='complete'&&!row.bpid"
                  color="primary" :text="$t(row.bpid?'onuploadproc':'uploadingfiles')" @click="pop('upload',row.id)"/></td>
                <td class="text-center"><v-btn color="error" :text="$t('delete')" @click="metaStore.dialog({shown:true,ttl:'deletesv',cont:'del_con',showcancel:true,istk:true,onok:()=>{
                  metaStore.dialog({shown:false})
                  _.delay(() =>delSv(row.id), 300)
                }})"/></td>
              </tr>
              <tr v-if="!meta.data.rows.length">
                <td :colspan="meta.heads.length+2" class="text-center">{{ $t('noresultsfound') }}</td>
              </tr>
            </tbody>
          </v-table>
        </v-card-text>
        <v-card-actions>
          <v-pagination class="ma-auto" v-if="meta.data.rows.length" :length="meta.data.totalPages" :total-visible="meta.data.pageCount" v-model="meta.search.page" @update:model-value="search"/>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
  <Teleport v-if="meta.poptype" to="#popbody">
    <v-card flat v-if="meta.poptype=='add'" min-width="400" rounded="0">
      <v-card-title>
        <v-row>
          <v-col align-self="center">{{ $t('registersv') }}</v-col>
          <v-col cols="2" class="text-right"><v-icon icon="mdi-close" class="cursor-pointer" @click="pop()"/></v-col>
        </v-row>
      </v-card-title>
      <v-alert class="ma-3">
        <p>{{$t('streetview_type')}}</p>
        <v-radio-group hide-details inline v-model="meta.newsv.layertype">
          <v-radio v-for="item in meta.layertypes" :label="$t(item)" :value="item"/>
        </v-radio-group>
        <v-select class="mb-4" hide-details disabled variant="outlined" density="compact" :label="$t('coordinatesystem')" :items="[{title:'EPSG:4326',value:4326}]" v-model="meta.newsv.epsg"/>
        <v-row no-gutters class="mb-4">
          <v-col>
            <v-select hide-details variant="outlined" density="compact" :items="meta.groups" v-model="meta.newsv.groupid" :label="$t('layergroups')" :item-props="item=>({title:item.nm,value:item.id})"/>
          </v-col>
          <v-col cols="2" class="text-right"><v-btn variant="outlined" size="40" :prepend-icon="meta.newsv.etc===null?'mdi-plus':'mdi-minus'" @click="meta.newsv.etc=meta.newsv.etc!=null?null:''"/></v-col>
        </v-row>
        <v-text-field v-if="meta.newsv.etc!=null" variant="outlined" density="compact" :label="$t('newgroupname')" :placeholder="$t('enteranameforyourgroupupto50characters')" maxlength="50"
          :rules="[validators.required]" v-model="meta.newsv.etc"/>
        <v-text-field variant="outlined" density="compact" :label="$t('streetview_name')" :placeholder="$t('enteranameforthesvupto50characters')" maxlength="50" :rules="[validators.required]" v-model="meta.newsv.nm"/>
      </v-alert>
      <v-card-actions>
        <v-row>
          <v-col class="text-right">
            <v-btn color="error" variant="elevated" class="me-3" :text="$t('cancel')" @click="pop()"/>
            <v-btn color="primary" variant="elevated" class="me-1" :text="$t('save')"
              :disabled="_.isEmpty(meta.newsv.nm)||(meta.newsv.etc!=null&&_.isEmpty(meta.newsv.etc))" @click="meta.addoverlay='con'"/>
          </v-col>
        </v-row>
      </v-card-actions>
      <v-overlay contained :model-value="meta.addoverlay!=null" class="align-center justify-center" persistent>
        <ConfirmCard v-if="meta.addoverlay=='con'" :ttl="$t('registersv')" cont="save" @cancel="meta.addoverlay=null" @confirm="()=>{
          if(meta.poptype=='add')addSv()
        }"/>
        <v-progress-circular v-if="meta.addoverlay=='loading'" color="primary" size="64" indeterminate/>
      </v-overlay>
    </v-card>
    <v-card flat v-if="meta.poptype=='upload'" min-width="680" rounded="0">
      <v-card-title>
        <v-row>
          <v-col align-self="center">{{ $t('fileattachments') }}</v-col>
          <v-col cols="2" class="text-right"><v-icon icon="mdi-close" class="cursor-pointer" @click="pop()"/></v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-alert style="max-height: calc(100vh - 200px);overflow: auto;">
          <v-row>
            <v-col cols="3" align-self="center">{{ $t('streetview') }}:</v-col>
            <v-col>{{meta.data.rows.find(sv=>sv.id==meta.selid).nm}} ({{ meta.selid }})</v-col>
          </v-row>
          <v-row>
            <v-col cols="3" align-self="center">{{$t('select_type')}}</v-col>
            <v-col>
              <v-radio-group hide-details variant="outlined" density="compact" v-model="meta.upfiletype" inline @update:model-value="()=>{
                  const fileinput=qsel('[name=files]');
                  if(fileinput)fileinput.value='';
                  meta.upfiles=[];
                  if(meta.upfilesection=='server'){
                    meta.seldir=null
                    serverFiles()
                  }
                }">
                <v-radio label="폴더" value="dir"></v-radio>
                <v-radio label="ZIP파일" value="zip"></v-radio>
              </v-radio-group>
          </v-col>
          </v-row>
          <v-row>
            <v-col cols="3" align-self="center">{{$t('fileattachments')}} {{ $t('type') }}:</v-col>
            <v-col>
              <v-radio-group hide-details variant="outlined" density="compact" v-model="meta.upfilesection" inline @update:model-value="()=>{
                if(meta.upfilesection=='server'){
                  meta.seldir=null
                  serverFiles()
                }
              }">
                <v-radio label="로컬파일/폴더" value="local"></v-radio>
                <v-radio label="서버파일/폴더" value="server"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3" align-self="center">{{$t('fileattachments')}}:</v-col>
            <v-col>
              <div v-if="meta.upfilesection=='local'" class="upfilelocal">
                <input type="file" name="files" class="w-100" @change="evt=>{
                  meta.upfiles=Array.from(evt.target.files)
                  meta.upproctype=meta.upfiles.length>=1000?'standalone':'internal'
                }"
                :webkitdirectory="meta.upfiletype=='dir'?'':undefined" :directory="meta.upfiletype=='dir'?'':undefined" :multiple="meta.upfiletype=='dir'?'':undefined" :accept="meta.upfiletype=='zip'?'.zip':undefined"/>
              </div>
              <div v-else class="upfileserver">
                <v-row>
                  <v-col cols="5" class="text-center">선택된 폴더/파일:<p class="font-weight-bold text-blue">{{meta.seldir?.name?meta.seldir?.name:'선택된 폴더 없음'}}</p></v-col>
                  <v-col cols="7">
                    <v-btn block density="compact" variant="outlined" text="외장디스크연결" @click="mountDisk()" style="margin-bottom: 2px;"/>
                    <v-btn block density="compact" variant="outlined" text="외장디스크해지" @click="unmountDisk()"/>
                    <div class="text-center">※외장하드 연결 시 [external_storage]<br>폴더 로 연결됩니다.</div>
                  </v-col>
                </v-row>
                <div class="border-thin" style="max-height: 300px; overflow: auto;">
                  <Vue3TreeVue wid :items="meta.serverfiles" @onSelect="item=>{
                    meta.seldir=item;
                    serverFiles(meta.upfiletype,item.meta.path);
                  }">
                    <template #item-prepend-icon="treeViewItem" >
                      <v-icon :icon="treeViewItem.meta?.isdir?'mdi-folder':'mdi-zip-box-outline'"/>
                    </template>
                    <template #item-append="treeViewItem">
                      <span v-if="treeViewItem.meta.isdir&&!treeViewItem.meta.isroot" class="text-green">[{{ treeViewItem.meta.childcnt }}]</span>
                    </template>
                  </Vue3TreeVue>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3" align-self="center">{{$t('detectptdist')}}(m):</v-col>
            <v-col><v-number-input hide-details variant="outlined" density="compact" v-model="meta.detectptdist" :precision="1"/></v-col>
          </v-row>
          <v-row>
            <v-col cols="3" align-self="center">{{$t('linkdist')}}(m):</v-col>
            <v-col><v-number-input hide-details variant="outlined" density="compact" v-model="meta.linkdist" :precision="1"/>
              <div>(참고)입력 시 촬영 간격의 약 1.8배의 거리를 입력하는게 좋습니다.</div>
              <div>예) 10M 간격 촬영 시 17 또는 18</div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3" align-self="center">{{$t('datetaken')}}:</v-col>
            <v-col><v-date-input hide-details prepend-icon="" prepend-inner-icon="$calendar" variant="outlined" density="compact" v-model="meta.upfiledt"/></v-col>
          </v-row>
          <v-row>
            <v-col cols="3" align-self="center">좌표값 종류:</v-col>
            <v-col>
              <v-radio-group hide-details inline v-model="meta.upfilepostype">
                <v-radio label="GPS파일" value="nmea"></v-radio>
                <v-radio label="EXIF" value="exif"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row v-if="meta.upfilepostype=='nmea'">
            <v-col cols="3" align-self="center">GPS 파일 확장자:</v-col>
            <v-col>
              <v-combobox hide-details variant="outlined" density="compact" :items="['txt', 'nmea']" v-model="meta.upfilenmeaext"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3" align-self="center">프로세스 타입:</v-col>
            <v-col>
              <v-radio-group hide-details inline v-model="meta.upproctype">
                <v-radio label="내부 프로세스" value="internal"></v-radio>
                <v-radio label="독립 프로세스" value="standalone"></v-radio>
              </v-radio-group>
              <div>※내부 프로세스: 속도↓ 서버부하↓ (대량일때 처리 중 사이트 느려짐)</div>
              <div>※독립 프로세스: 속도↑ 서버부하↑ (대량일때도 처리 중 사이트 안 느려짐!)</div>
            </v-col>
          </v-row>
        </v-alert>
      </v-card-text>
      <v-card-actions>
        <v-row>
          <v-col class="text-right">
            <v-btn color="error" variant="elevated" class="me-3" :text="$t('cancel')" @click="pop()"/>
            <v-btn color="primary" variant="elevated" class="me-1" :text="$t('upload')"
              :disabled="!_.isNumber(meta.detectptdist)||!_.isNumber(meta.linkdist)" @click="uploadSv"/>
          </v-col>
        </v-row>
      </v-card-actions>
      <v-overlay contained :model-value="meta.uploadoverlay!=null" class="align-center justify-center" persistent>
        <v-progress-circular color="primary" size="64" indeterminate/>
      </v-overlay>
    </v-card>
  </Teleport>
</template>
<style>
.mansvcol{width: 200px;}
.mansvcol > .v-card{max-width: calc(100vw - 420px);}
.mansvcol .v-number-input__control button{border-width: 0 !important;}
.mansvtbl{border: 1px solid #e0e0e0;margin-top: 18px;}
.mansvtbl th{background-color: #eee !important;text-align: center !important; max-width: 180px;}
.mansvtbl td{text-align: center;}
</style>
